'use client'

import { usePathname } from 'next/navigation'

type Props = {
  children: React.ReactNode
  defaultHeader: React.ReactNode
  languagesHeader: React.ReactNode
  footer: React.ReactNode
}

export function LayoutChrome({ children, defaultHeader, languagesHeader, footer }: Props) {
  const pathname = usePathname()
  const slug = pathname.split('/').filter(Boolean).at(-1)

  const isIgamingHobbies = slug === 'igaming-hobbies-survey'

  return (
    <>
      {isIgamingHobbies ? languagesHeader : defaultHeader}

      <main className="layout__main" role="main">
        {children}
      </main>

      {!isIgamingHobbies && <div className="layout__footer-wrapper">{footer}</div>}
    </>
  )
}
